import React from 'react';
import { Button } from '../../ui/Button';
export const AIServices = () => {
  const services = [{
    subtitle: 'Leadership',
    title: 'AI Strategy & Vision',
    items: ['AI opportunity assessment across product & ops', 'Multi-year AI roadmap development', 'Executive stakeholder alignment', 'Competitive AI landscape analysis', 'Board-ready AI narrative'],
    gradient: 'from-amber-400 via-orange-500 to-amber-300'
  }, {
    subtitle: 'Discovery',
    title: 'Use Case Discovery & Prioritization',
    items: ['AI use case ideation workshops', 'ROI & feasibility scoring', 'Build vs buy vs partner analysis', 'POC planning & success criteria', 'Risk and compliance review'],
    gradient: 'from-blue-600 via-indigo-500 to-purple-500'
  }, {
    subtitle: 'Delivery',
    title: 'AI Product Development',
    items: ['LLM integration & prompt engineering', 'Evaluation frameworks & guardrails', 'Production AI feature shipping', 'Model selection & infrastructure', 'Continuous improvement pipelines'],
    gradient: 'from-green-500 via-teal-500 to-cyan-500'
  }, {
    subtitle: 'Enablement',
    title: 'Team Enablement & Governance',
    items: ['AI literacy training for teams', 'Responsible AI policies & guardrails', 'Hiring support for internal AI talent', 'Tooling and workflow integration', 'Knowledge transfer & documentation'],
    gradient: 'from-orange-500 via-red-500 to-pink-500'
  }];
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  return <section id="ai-services" className="py-20 bg-white relative overflow-hidden" data-id="element-295">
      <div className="absolute top-0 left-0 w-72 h-72 bg-purple-50 rounded-full opacity-50 -ml-36 -mt-36" data-id="element-296"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-purple-50 rounded-full opacity-40 -mr-40 -mb-40" data-id="element-297"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-298">
        <div className="text-center mb-16" data-id="element-299">
          <h2 className="text-3xl md:text-5xl font-bold mb-2 text-black max-w-4xl mx-auto leading-tight" data-id="element-300">
            Every kind of AI leadership work,
            <br data-id="element-301" />
            <span className="italic font-serif" data-id="element-302">under one roof</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-303">
          {services.map((service, index) => <div key={index} className={`relative h-[500px] rounded-3xl overflow-hidden bg-gradient-to-br ${service.gradient} shadow-lg transform transition-transform hover:scale-105`} data-id="element-304">
              <div className="absolute inset-0 bg-black/10" data-id="element-305"></div>
              <div className="absolute inset-0 flex flex-col justify-center items-center p-8" data-id="element-306">
                <div className="bg-black/70 backdrop-blur-sm rounded-2xl p-6 w-[85%] shadow-xl" data-id="element-307">
                  <h3 className="block text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-308">
                    {service.title}
                  </h3>
                  <ul className="space-y-2" data-id="element-309">
                    {service.items.map((item, idx) => <li key={idx} className="text-white/90 flex items-start" data-id="element-310">
                        <span className="mr-2" data-id="element-311">•</span>
                        <span data-id="element-312">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>)}
        </div>
        <div className="text-center mt-12" data-id="element-313">
          <Button variant="primary" onClick={openCalendly} className="text-lg" data-id="element-314">
            Speak with an AI Lead
          </Button>
        </div>
      </div>
    </section>;
};